import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { useTranslation } from "@coworker/locales";
import { Text } from "../Atoms/Text";

interface PriceLevelProps {
  priceLevel: string;
}

const PriceLevelMap: Record<string, string> = {
  BREATHTAKING_ITEM: "Lowest/BTI",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
};

export const PriceLevel = ({ priceLevel }: PriceLevelProps) => {
  const { t } = useTranslation();

  const displayValue = PriceLevelMap[priceLevel] || priceLevel;
  const addonContent = priceLevel ? <Text text={displayValue} grey /> : "";

  return (
    <FixaListViewItem
      inset
      title={t("priceLevelString")}
      addOn={addonContent}
      emphasised
    />
  );
};
